import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { AcademicYear } from '../../../models/academic-year';
import { AppSettings } from '../../../utils/app-settings';

@Injectable({
  providedIn: 'root'
})
export class AcademicYearService {

  constructor(private http: HttpClient) { }

  private _academicYear: ReplaySubject<AcademicYear> = new ReplaySubject<AcademicYear>(1);
  private http_fetched = false;

  getAcademicYear(): Observable<AcademicYear> {
    if (!this.http_fetched) {
      this.http_fetched = true;
      this.http.get<AcademicYear>(`${AppSettings.apiUrl}users/academic-year`)
        .subscribe((res) => {
          this._academicYear.next(res);
        },
          (error) => {
            console.error(error);
            this.http_fetched = false;
          }
        );
    }
    return this._academicYear.asObservable();
  }
}
